export default "__VITE_ASSET__CixhVJau__"